import * as React from 'react';
import { decodeHTMLEntities } from "../helpers/utils.ts";
import type { PageSectionData } from "../page/content.types.ts";
import tailwindCompiler from "../helpers/tailwindCompiler.ts";
import RenderContent from "./renderContent.tsx";

export async function renderCssFromPageContent(content: PageSectionData[], renderToString: Function) {
	let html = await renderToString(<>
		<div className="cms-sections">
			<RenderContent content={content}/>
		</div>
	</>);

	return await tailwindCompiler(decodeHTMLEntities(html));
}
